var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20 10c0 .92-.08 1.67-1 1.67h-7.33V19c0 .92-.75 1-1.67 1s-1.67-.08-1.67-1v-7.33H1c-.92 0-1-.75-1-1.67s.08-1.67 1-1.67h7.33V1c0-.92.75-1 1.67-1s1.67.08 1.67 1v7.33H19c.92 0 1 .75 1 1.67"
})));
export default SvgPlus;